/**
 * 訂單金額顯示規則。
 *
 * 由瓦斯行設定 `system_setting.hide_amount_on_pending` 控制：
 * 只有「開啟此設定的瓦斯行」的「待確認（pending）」訂單才隱藏金額——因為這類瓦斯行採人工確認金額，
 * 待確認時顯示的金額並非最終應付金額，容易誤導客戶。瓦斯行接單後（待接單／配送中／已完成）金額已確定 → 正常顯示；
 * 未開啟此設定的瓦斯行則一律正常顯示金額。
 *
 * per-order 旗標由後端訂單 API 依各訂單所屬 supplier 帶入（列表「全部」分頁會混多家瓦斯行，故需 per-order）。
 * 三處訂單金額顯示（列表卡片、訂單詳情、帳戶訂單紀錄）共用此判斷，確保規則一致。
 */

/** 待確認訂單狀態值（與 OrderListStatusEnum.pending / 帳戶紀錄 raw status 皆為 "pending"）。 */
const PENDING_STATUS = "pending";

/**
 * 此訂單是否應隱藏金額。
 * @param hideAmountOnPending 該訂單所屬 supplier 的 system_setting.hide_amount_on_pending（後端帶入）。
 * @param status 訂單狀態字串（uiStatus 或後端 raw status，待確認皆為 "pending"）。
 * @returns true = 隱藏金額（此瓦斯行開設定且訂單為待確認）；false = 正常顯示金額。
 */
export function isOrderAmountHidden(
  hideAmountOnPending: boolean | null | undefined,
  status: string | null | undefined,
): boolean {
  return hideAmountOnPending === true && status === PENDING_STATUS;
}
